import {remCalc} from '_themeUtils'

const productRecommendations = {
    ProductRecommendations: {
        baseStyle: () => ({
            wrapper: {
                w: '100%',
                gap: remCalc(50),
            },
            tabsContainer: {
                w: '100%',
                // Mobile: no left inset (carousel is centered/full-bleed). Tablet (Figma node 60805-36907):
                // 24px inset, matching the PDP details container side padding. Desktop: 60px inset.
                pl: {base: 0, md: remCalc(24), lg: 'spacing.15'},
            },
        }),
    },
}

export default productRecommendations
